module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slide slide-link"
  }, [_c('div', {
    staticClass: "slide-media slide-loadable",
    class: {
      'loaded': _vm.imageLoaded
    },
    style: ({
      backgroundImage: 'url(' + _vm.photoSource + ')'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "slide-body"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'photoset',
        params: {
          id: _vm.details.id
        }
      }
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.details.title._content) + "\n\t\t")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2bfefd31!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PhotosetIntro.vue
// module id = 120
// module chunks = 2